import { Trophy } from 'lucide-react';
import React from 'react';

export const teamColors = {
  Yellow: { bg: 'bg-team-yellow', text: 'text-team-yellow', border: 'border-team-yellow', glow: 'glow-team-yellow' },
  Red: { bg: 'bg-team-red', text: 'text-team-red', border: 'border-team-red', glow: 'glow-team-red' },
  Blue: { bg: 'bg-team-blue', text: 'text-team-blue', border: 'border-team-blue', glow: 'glow-team-blue' },
  Ocean: { bg: 'bg-team-blue', text: 'text-team-blue', border: 'border-team-blue', glow: 'glow-team-blue' },
  Green: { bg: 'bg-team-green', text: 'text-team-green', border: 'border-team-green', glow: 'glow-team-green' },
  Purple: { bg: 'bg-team-purple', text: 'text-team-purple', border: 'border-team-purple', glow: 'glow-team-purple' },
} as const;

export const defaultTeamColors = { bg: 'bg-muted', text: 'text-foreground', border: 'border-border', glow: 'glow-primary' };

export const getTeamColors = (teamName: string) => {
  return teamColors[teamName as keyof typeof teamColors] || defaultTeamColors;
};

export const formatGameNumber = (gameNumber: string | number) => {
  return String(gameNumber).padStart(3, '0');
};

/**
 * Parse German date format "DD.MM.YYYY - HH:MM Uhr" from game_data.timestamp
 */
export const parseGameDate = (gameData: any): Date => {
  try {
    const timestampStr = gameData?.timestamp;
    if (timestampStr && typeof timestampStr === 'string') {
      const match = timestampStr.match(/(\d{2})\.(\d{2})\.(\d{4})\s*-\s*(\d{2}):(\d{2})/);
      if (match) {
        const [, day, month, year, hour, minute] = match;
        return new Date(parseInt(year), parseInt(month) - 1, parseInt(day), parseInt(hour), parseInt(minute));
      }
    }
  } catch {
    // Fallback
  }
  return new Date(0);
};

export const formatTimestamp = (timestamp: string) => {
  const date = new Date(timestamp);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffMins = Math.floor(diffMs / 60000);

  if (diffMins < 1) return 'gerade eben';
  if (diffMins < 60) return `vor ${diffMins} Min.`;

  const diffHours = Math.floor(diffMins / 60);
  if (diffHours < 24) return `vor ${diffHours} Std.`;

  return date.toLocaleString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

export const isRateLimitError = (str: string) =>
  str.includes('Rate limit') ||
  str.includes('429') ||
  str.includes('rate limit') ||
  str.includes('Rate limit exceeded');
